import { ref, watchEffect } from 'vue'

export type ThemeMode = 'auto' | 'light' | 'dark'
export type EffectiveTheme = 'light' | 'dark'

const STORAGE_KEY = 'theme-mode'

function loadStored(): ThemeMode {
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'light' || v === 'dark' ? v : 'auto'
}

const mode = ref<ThemeMode>(loadStored())

function systemTheme(): EffectiveTheme {
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

function applyEffectiveTheme(m: ThemeMode) {
  const effective: EffectiveTheme = m === 'auto' ? systemTheme() : m
  document.documentElement.setAttribute('data-theme', effective)
}

watchEffect(() => {
  applyEffectiveTheme(mode.value)
  if (mode.value === 'auto') {
    localStorage.removeItem(STORAGE_KEY)
  } else {
    localStorage.setItem(STORAGE_KEY, mode.value)
  }
})

// React to OS-level theme changes while in auto mode
window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', () => {
  if (mode.value === 'auto') applyEffectiveTheme('auto')
})

export function useTheme() {
  function cycle() {
    mode.value = mode.value === 'auto' ? 'light' : mode.value === 'light' ? 'dark' : 'auto'
  }
  return { mode, cycle }
}

export function initTheme() {
  applyEffectiveTheme(mode.value)
}
